package network

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch

/**
 * Web no tiene SDK de Crashlytics. Estrategia:
 * - Siempre loguea a la consola del navegador.
 * - Best-effort: empuja el error a RTDB `error_logs` para verlo en la consola de Firebase.
 */
actual object CrashReporter {
    private val scope = CoroutineScope(Dispatchers.Main)
    private var userId: String = ""
    private var userEmail: String = ""

    actual fun log(message: String) {
        console.log("SmartVan: $message")
    }

    actual fun recordException(throwable: Throwable, context: String) {
        console.error("SmartVan ERROR [$context]: ${throwable.message ?: throwable.toString()}")
        scope.launch {
            try {
                val db = FirebaseClient.database
                db.reference("error_logs").push().setValue(
                    mapOf(
                        "context" to context,
                        "message" to (throwable.message ?: throwable.toString()),
                        "type" to throwable::class.simpleName.orEmpty(),
                        "uid" to userId,
                        "email" to userEmail,
                        "plataforma" to "web",
                        "timestamp" to org.example.abigail.obtenerMilisegundosActuales()
                    )
                )
            } catch (_: Throwable) { /* best-effort */ }
        }
    }

    actual fun setUserId(id: String) { userId = id }

    actual fun setUserContext(email: String, rol: String) {
        userEmail = email
    }
}
